import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AreaRepository from '@/shared/http/repositories/configuration/area'
import ImageTypeRepository from '@/shared/http/repositories/configuration/imagetype'
import ImageTypeModel from '@/shared/models/configuration/imagetypemodel'
import ImageTypeForms from './imagetype-form'

export default {
  name: 'ImageType',
  mixins: [ActionsForm],
  data () {
    return {
      data: ImageTypeModel,
      form: ImageTypeForms
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllArea()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      ImageTypeRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      ImageTypeRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      ImageTypeRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      ImageTypeRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/imagetype/imagetype.js